var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"notificationIconButton"},[_vm._t("default"),(_vm.count > 0)?_c('span',{staticClass:"notificationIconButton__badge"},[_vm._v(_vm._s(_vm.count))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }